import {
  ButtonLevels,
  ButtonSizes,
  SubNavPositions,
} from '@zipari/shared-ds-util-button';

export const mockButtonConfig = {
  action: '',
  active: false,
  content: '',
  disabled: false,
  icon: '',
  iconSize: '',
  id: '',
  isIconRight: false,
  isLink: false,
  level: ButtonLevels.text,
  openRouteInNewTab: false,
  options: null,
  route: '',
  size: ButtonSizes.fit,
  hasSubnav: false,
  subnav: null,
  menuPosition: SubNavPositions.bottom,
  leftAlignedText: false,
};
